import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const LinkIcon = props => {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M7.667 10.333l-.586-.586a2 2 0 010-2.828l4.505-4.505a2 2 0 012.828 0l1.172 1.171a2 2 0 010 2.829L14 8m-3.667-.334l.586.586a2 2 0 010 2.829l-4.505 4.505a2 2 0 01-2.828 0l-1.172-1.172a2 2 0 010-2.829L4 10"
        stroke="#3D87BF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default LinkIcon;
